exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".item-item-4TpfbpL6mwr{}.item-item-4TpfbpL6mwr>*:not(:last-child){margin-right:8px}.item-title-5viQUZkfmwr{flex-shrink:1}.item-inline-70TyVwBSmwr{}.item-inline-70TyVwBSmwr .item-description-2hr6xf0jmwr{margin-left:8px;flex-shrink:9999999}@media screen and (-ms-high-contrast: black-on-white){.item-item-4TpfbpL6mwr:not(.item-disabled-6KEXCV7gmwr) .item-text-7G1wbxfgmwr,.item-inline-70TyVwBSmwr:not(.item-disabled-6KEXCV7gmwr) .item-text-7G1wbxfgmwr{color:currentColor}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"item": "item-item-4TpfbpL6mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["ellipsize"] + "",
	"title": "item-title-5viQUZkfmwr",
	"inline": "item-inline-70TyVwBSmwr item-item-4TpfbpL6mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["ellipsize"] + "",
	"description": "item-description-2hr6xf0jmwr",
	"disabled": "item-disabled-6KEXCV7gmwr",
	"text": "item-text-7G1wbxfgmwr"
};